import { useMemo } from 'react';
import { css } from '@emotion/react';
import { Card, Grid } from '@material-ui/core';
import { colors } from '@/styles';
import { Body1, Header2 } from '../OrderDetailsPage/Crossdocking/blocks';
import { startCase } from 'lodash';

const DriverSummaryCard = ({ order, events }) => {
    const isAssigned = useMemo(() => {
        return (events || []).some((e) => {
            return !!(e?.driver_id || e?.wh_driver_id);
        });
    }, [events]);

    const itemQty = useMemo(() => {
        return (order.itemsByOrderId || []).reduce((qty, item) => {
            return (item.quantity || 1) + qty;
        }, 0);
    }, [order]);

    const activeExceptions = useMemo(() => {
        const mappings = order?.exceptions || [];
        const exceptions = mappings.map((m) => m?.exception).filter((e) => !!e);
        return exceptions
            .filter((e) => (e.status || '').toUpperCase() !== 'RESOLVED')
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }, [order]);

    return (
        <Card
            css={css`
                margin: 12px;
                padding: 12px 12px 24px 12px;
            `}
        >
            <Grid direction="column" container>
                {!isAssigned && (
                    <Grid
                        item
                        css={css`
                            font-size: 14px;
                            font-weight: 500;
                            color: ${colors.reds.primary};
                            margin-bottom: 12px;
                        `}
                    >
                        <span>
                            This order has not been assigned to a driver, therefore, cannot be started. Please reach out
                            to your admin to assign you the order.
                        </span>
                    </Grid>
                )}

                {activeExceptions.length > 0 && (
                    <Grid
                        item
                        css={css`
                            font-size: 14px;
                            font-weight: 500;
                            color: ${colors.oranges.primary};
                            margin-bottom: 12px;
                        `}
                    >
                        <span>
                            Active exception: {startCase(activeExceptions[0]?.type || 'Unknown')}
                            {activeExceptions[0]?.reason ? ` — ${activeExceptions[0].reason}` : ''}
                            {activeExceptions.length > 1 ? ` (+${activeExceptions.length - 1} more)` : ''}
                        </span>
                    </Grid>
                )}

                <Grid item>
                    <Header2>{order.order_number}</Header2>
                </Grid>
                <Grid item>
                    <Body1>Freight type: {startCase(order.freight_type)}</Body1>
                </Grid>
                <Grid item>
                    <Body1>{startCase(order.order_type)}</Body1>
                </Grid>
                <Grid item>
                    <Body1>{itemQty} Items</Body1>
                </Grid>
                <Grid item>
                    <Body1>Pickup: {order.pickup_date_formatted}</Body1>
                </Grid>
                <Grid item>
                    <Body1>Dropoff: {order.delivery_date_formatted}</Body1>
                </Grid>
            </Grid>
        </Card>
    );
};

export default DriverSummaryCard;
